import { render, staticRenderFns } from "./editDialog.vue?vue&type=template&id=485d98b8&scoped=true&"
import script from "./editDialog.vue?vue&type=script&lang=js&"
export * from "./editDialog.vue?vue&type=script&lang=js&"
import style0 from "./editDialog.vue?vue&type=style&index=0&id=485d98b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485d98b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('485d98b8')) {
      api.createRecord('485d98b8', component.options)
    } else {
      api.reload('485d98b8', component.options)
    }
    module.hot.accept("./editDialog.vue?vue&type=template&id=485d98b8&scoped=true&", function () {
      api.rerender('485d98b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operate/backBranch/dialog/editDialog.vue"
export default component.exports